import jalaliMoment from "jalali-moment";
const ConvertToShamsi = (miladiDate: any) => {
  // Convert to Shamsi (Persian) date
  const shamsiDate = jalaliMoment(miladiDate)
    .add(3, "hours")
    .add(30, "minutes")
    .locale("fa")
    .format("HH:mm - YYYY/MM/DD");
  return shamsiDate;
};

export default ConvertToShamsi;
